import { render, staticRenderFns } from "./ConnectionsSwitchView.vue?vue&type=template&id=c21b1230&scoped=true&"
import script from "./ConnectionsSwitchView.vue?vue&type=script&lang=js&"
export * from "./ConnectionsSwitchView.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionsSwitchView.vue?vue&type=style&index=0&id=c21b1230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21b1230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
